import { render, staticRenderFns } from "./SellersHome.vue?vue&type=template&id=681f649c&scoped=true&"
import script from "./SellersHome.vue?vue&type=script&lang=js&"
export * from "./SellersHome.vue?vue&type=script&lang=js&"
import style0 from "./SellersHome.vue?vue&type=style&index=0&id=681f649c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "681f649c",
  null
  
)

export default component.exports